var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H0V48H48V0Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_411_504)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 48C37.256 48 48 37.255 48 24C48 10.744 37.256 -0.000976562 24 -0.000976562C10.745 -0.000976562 0 10.744 0 24C0 37.255 10.745 48 24 48Z",
  fill: "#EAEAEA"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H0V48H48V0Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_411_504)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 48C37.256 48 48 37.255 48 24C48 10.745 37.256 0 24 0C10.744 0 0 10.745 0 24C0 37.255 10.744 48 24 48Z",
  fill: "#EAEAEA"
}));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M48 0H0V48H48V0Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_411_504)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 9L12 14.455V22.637C12 30.205 17.12 37.282 24 39C30.88 37.282 36 30.205 36 22.636V14.454L24 9ZM24 23.986H33.333C32.627 29.605 28.96 34.609 24 36.177V24H14.667V16.227L24 11.986V23.986Z",
  fill: "#ED4300"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 23.9858H33.333C32.627 29.6048 28.96 34.6088 24 36.1768V23.9998H14.667V16.2268L24 11.9858V23.9858Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_411_504"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})));

var SvgShieldIcon = function SvgShieldIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_504)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_411_504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref2), _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_411_504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref4), _ref5, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_411_504",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref6), _ref7), _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShieldIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shield-icon.31114c1c.svg";
export { ForwardRef as ReactComponent };